import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SideMenuDashboard from "./sideMenu/SideMenuDashboard";
import TopBar from "./TopBar";
import { getUserData } from "../../utils/localStorage";
import { getDashboardPath, THEMES } from "../../constants";
import LoadingSpinner from "../../components/uiElements/loadingSpinner/LoadingSpinner";
import changeTheme from "../../utils/changeTheme";
import { onMessageListener } from "../../firebase";
import Modals from "../../components/uiElements/popupModal/modal";
import format from "date-fns/format";
import moment from "moment";
import { NOTIFICATION_SOUND } from "../../constants";
import {
  getMeridiem,
  parseDateToLocal,
  parseTimeToLocal,
} from "../../utils/parseDateTime";
import { updateUserData } from "../../utils/localStorage";
import audioService from "../../services/audioService";

import * as actions from "../../store/actions";
import * as workerTimers from "worker-timers";
import ReminderModal from "../../components/uiElements/modal/ReminderModal";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import ChatWindow from "../../pages/Dashboard/ConciergeService/ChatWindow/ChatWindow";
import { getConciergeServiceAction } from "../../store/actions/dashboardActions";

let DashboardLayout = ({
  children,
  apiUtil,
  personalisedExperience,
  updateAvailablePermission,
  appointmentData,
  logout,
}) => {
  let dispatch = useDispatch();
  const [notification, setNotification] = useState({});
  const [prevId, setPrevId] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [openChatWindow, setOpenChatWindow] = useState(false);
  const [chatDetails, setChatDetails] = useState({});
  const [ringInterval, setRingInterval] = useState(null);
  const [audioRef, setAudioRef] = useState(null);
  const location = useLocation();
  useEffect(() => {
    // dispatch(getConciergeServiceAction());
    var intervalId = workerTimers.setInterval(() => {
      reminder();
    }, 1000);
    return function cleanup() {
      workerTimers.clearInterval(intervalId);
    };
  });

  const history = useHistory();

  const viewMode = localStorage.getItem("viewMode");

  useEffect(() => {
    dispatch(getConciergeServiceAction());
  }, []);

  // Manage visit now ringtone across all tabs
  useEffect(() => {
    console.log("🔍 Visit Now data changed:", appointmentData?.visitNow);
    
    if (appointmentData?.visitNow && Object.keys(appointmentData.visitNow).length > 0) {
      const status = appointmentData.visitNow.doctor_status || appointmentData.visitNow.guest_doctor_status;
      console.log("📊 Visit Now status:", status, "Audio playing:", audioService.isPlaying);
      
      if (status === "REQUESTED") {
        audioService.play();
      } else {
        console.log("🚫 Status not REQUESTED, stopping audio");
        audioService.stop();
      }
    } else {
      console.log("❌ No Visit Now appointment, stopping audio");
      audioService.stop();
    }
  }, [appointmentData?.visitNow]);

  // Cleanup audio when component unmounts
  useEffect(() => {
    return () => {
      stopNotificationRing();
      audioService.cleanup();
    };
  }, [audioRef, ringInterval]);

  let notificationObj = {};
  let user = getUserData();
  let userId = user?.user;
  useEffect(() => {
    dispatch(actions.getChatMessagesCountAction());
    const userData = getUserData();
    if (userData?.user_theme) {
      let theme;

      theme =
        (personalisedExperience &&
          THEMES.filter(
            (theme) => theme.id === personalisedExperience.selectedThemeId
          )[0]) ||
        THEMES.find((theme) => theme.name === userData?.user_theme);

      changeTheme(theme);
    }
    // eslint-disable-next-line
  }, []);

  const selectedScheduleDate = format(new Date(), "yyyy-MM-dd");

  const playNotification = () => {
    // Stop any existing notification first
    stopNotificationRing();

    var audio = new Audio(NOTIFICATION_SOUND);
    audio.loop = true;
    audio.play();
    setAudioRef(audio);

    // Stop ringing after 1 minute
    const timeout = setTimeout(() => {
      stopNotificationRing();
    }, 60000);

    setRingInterval(timeout);
  };

  const stopNotificationRing = () => {
    if (audioRef) {
      audioRef.pause();
      audioRef.currentTime = 0;
      setAudioRef(null);
    }
    if (ringInterval) {
      clearTimeout(ringInterval);
      setRingInterval(null);
    }
  };

  const reminder = () => {
    if (appointmentData.scheduled) {
      // eslint-disable-next-line
      appointmentData?.scheduled[selectedScheduleDate]?.map((apt) => {
        if (
          apt?.startTime === moment(new Date()).add(10, "m").format("HH:mm")
        ) {
          if (apt?.id !== prevId) {
            setOpenModal(true);
            playNotification();
          }
          setPrevId(apt?.id);
        }
      });
    }
  };

  onMessageListener()
    .then((payload) => {
      if (Object.keys(payload?.data)?.length > 0) {
        updateUserData({
          notification_count: true,
        });
        if (payload?.data.notification_type === "APPOINTMENT_CHARGE") {
        } else if (payload?.data.notification_type === "NO_SHOW_FEES") {
          window.location.reload();
        } else if (
          payload?.data.notification_type === "DOSESPOT_PRESCRIPTION"
        ) {
          payload["data"]["message"] = payload?.data
            ? "Prescription has been successfully approved and sent"
            : payload?.data?.message;
          setNotification(payload?.data);
        } else if (payload?.data.notification_type === "CHAT_NOTIFICATION") {
          let notifiy_param = JSON.parse(payload?.data.params);

          updateUserData({
            chat_notify: {
              is_chat_listen: true,
              patient_user: notifiy_param["sender"],
              appointmentID: notifiy_param["appointment_id"],
              chat_type: notifiy_param["type"],
            },
          });

          dispatch(
            actions.onMessageNotification({ is_chat_notification: true })
          );
          const url = location.pathname;
          const lastIndex = url.lastIndexOf("/");
          const result = url.substring(0, lastIndex + 1);
          if ("/dashboard/patients/detail/" == result) {
            // Do nothing if the condition is true
          } else {
            window.location.reload();
          }
        } else if (payload?.data.notification_type === "LOGGEDIN_OTHERDEVICE") {
          logout();
        } else if (payload?.data.notification_type === "VISIT_NOW_DENIED") {
          window.location.reload();
        } else if (payload?.data.notification_type === "AUTO_CANCELLED") {
          const obj = JSON.parse(payload?.data?.params);
          toast.success(payload?.data?.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          setTimeout(function () {
            window.location.reload();
          }, 3000);
        } else if (payload?.data.notification_type === "NEW_MESSAGE") {
          dispatch(actions.getChatMessagesCountAction());
          const obj = JSON.parse(payload?.data?.params);
          let senderDetails = {
            chat_room: obj?.chat_connection,
            patient: {
              name: obj?.sender_details?.name,
              image: obj?.sender_details?.image,
            },
          };

          setChatDetails(senderDetails);
          toast.success(
            <span
              onClick={() => {
                setOpenChatWindow(!openChatWindow);
              }}
            >
              {payload?.data?.message}
            </span>,
            {
              position: toast.POSITION.BOTTOM_RIGHT,
            }
          );
        } else if (
          payload?.data.notification_type === "NEW_SUBSCRIPTION_REQUEST"
        ) {
          JSON.parse(payload?.data?.params);
          toast.success(payload?.data?.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          dispatch(actions.getChatMessagesCountAction());
        } else {
          setNotification(payload?.data);
          if (payload?.data.notification_type === "VISIT_NOW") {
            playNotification();
          } else {
            var audio = new Audio(NOTIFICATION_SOUND);
            audio.play();
          }
          dispatch(actions.getChatMessagesCountAction());
        }
      }
    })
    .catch((err) => console.log("failed: ", err));

  let popupButton;

  if (notification?.notification_type === "NUDGE_PERMISSION")
    popupButton = {
      label: "Make Yourself Available",
      onclick: () => {
        stopNotificationRing();
        setNotification({});
        updateAvailablePermission(true);
      },
    };
  else if (notification?.notification_type === "CANCELED_APPOINTMENT") {
    notificationObj = JSON.parse(notification?.params);
    popupButton = {
      label: "Okay",
      onclick: () => {
        stopNotificationRing();
        setNotification({});
      },
    };
  } else if (notification?.notification_type == "DOSESPOT_PRESCRIPTION") {
    popupButton = {
      label: "Okay",
      onclick: () => {
        stopNotificationRing();
        setNotification({});
      },
    };
  } else if (
    notification?.notification_type == "BOOK_APPOINTMENT" &&
    notification?.user_id == userId
  ) {
    popupButton = {
      label:
        notification?.notification_type == "BOOK_APPOINTMENT"
          ? "Go To Requests"
          : "Go To Appointment",
      onclick: () => {
        stopNotificationRing();
        setNotification({});
        history.location.pathname === getDashboardPath("/appointments/requests")
          ? window.location.reload()
          : notification?.notification_type == "BOOK_APPOINTMENT"
          ? history.push(
              getDashboardPath("/appointments/requests"),
              localStorage.setItem("playRing", false)
            )
          : history.push(getDashboardPath("/appointments/scheduled"));
      },
    };
  } else if (
    notification?.notification_type == "CALL_STARTED" &&
    notification?.user_id == userId
  ) {
    var value = notification?.params;
    const obj = JSON.parse(value);
    popupButton = {
      label:
        notification?.notification_type == "CALL_STARTED"
          ? "Go To Appointment"
          : "Go To Appointment",
      onclick: () => {
        stopNotificationRing();
        setNotification({});
        history.push({
          pathname: getDashboardPath("/appointments/scheduled"),
          state: { pop: true, appointment_id: obj?.appointment_id },
        })
          ? window.location.reload()
          : notification?.notification_type == "CALL_STARTED"
          ? history.push({
              pathname: getDashboardPath("/appointments/scheduled"),
              state: { pop: true, appointment_id: obj?.appointment_id },
            })
          : history.push({
              pathname: getDashboardPath("/appointments/scheduled"),
              state: { pop: true, appointment_id: obj?.appointment_id },
            });
      },
    };
  } else {
    popupButton = {
      label:
        notification?.notification_type == "VISIT_NOW"
          ? "Go To Visit Now"
          : "Go To Appointment",
      onclick: () => {
        stopNotificationRing();
        setNotification({});
        history.location.pathname === getDashboardPath("/appointments")
          ? window.location.reload()
          : notification?.notification_type == "VISIT_NOW"
          ? history.push(
              getDashboardPath("/appointments"),
              localStorage.setItem("playRing", false)
            )
          : history.push(getDashboardPath("/appointments/scheduled"));
      },
    };
  }

  return (
    <React.Fragment>
      <ReminderModal openModal={openModal} setOpenModal={setOpenModal} />
      <Modals
        isOpen={Object.keys(notification)?.length > 0}
        closeModal={() => {
          stopNotificationRing();
          setNotification({});
        }}
        onBackdropClick={true}
        styles={{
          content: {
            minWidth: "450px",
            maxWidth: "450px",
          },
        }}
        title={"UrgiDoctor"}
        btnDark={popupButton}
      >
        <React.Fragment>
          <button
            onClick={() => {
              stopNotificationRing();
              setNotification({});
            }}
            className="close fileClose"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <p className="mx-auto text-center denyAppointmentText">
            {notification?.notification_type !== "CANCELED_APPOINTMENT"
              ? notification?.message
              : notification?.message
                  .replace(
                    "%s",
                    format(
                      parseDateToLocal(notificationObj?.appointment_date),
                      "MMM dd, yyyy"
                    )
                  )
                  .replace(
                    "%s",
                    `${parseTimeToLocal(
                      notificationObj?.appointment_time,
                      notificationObj?.appointment_date
                    )} ${getMeridiem(
                      parseTimeToLocal(
                        notificationObj?.appointment_time,
                        notificationObj?.appointment_date
                      )
                    )}`
                  )}
          </p>
        </React.Fragment>
      </Modals>
      <div>
        <div className="d-flex">
          {viewMode ? (
            <>
              <div
                className="col-md-12 m-0 p-0"
                style={{
                  position: "initial",
                }}
              >
                <div className="p-4">{children}</div>
              </div>
            </>
          ) : (
            <>
              <div className="col-md-2 m-0 p-0 sideMenuWidth">
                <SideMenuDashboard />
              </div>
              <div
                className="col-md-10 m-0 p-0"
                style={{
                  position: "initial",
                }}
              >
                <TopBar />
                <div className="p-4">{children}</div>
              </div>
            </>
          )}
        </div>
      </div>
      {apiUtil.isLoading && !apiUtil.show && (
        <div className="center-content">
          <LoadingSpinner asOverlay={true} />
        </div>
      )}
      <ChatWindow
        isOpen={openChatWindow}
        chatDetails={chatDetails}
        setIsOpen={setOpenChatWindow}
      />
    </React.Fragment>
  );
};

const mapStoreToProps = ({ api, onboarding, dashboard }) => ({
  apiUtil: api,
  personalisedExperience: onboarding.personalisedExperience,
  appointmentData: dashboard.appointments,
});

const mapDispatchToProps = (dispatch) => ({
  updateAvailablePermission: (is_available) =>
    dispatch(actions.updateAvailablePermission(is_available)),
  logout: () => dispatch(actions.logout()),
  updateAvailablePermissionOnly: (is_available) =>
    dispatch(actions.updateAvailablePermissionOnly(is_available)),
});

export default connect(mapStoreToProps, mapDispatchToProps)(DashboardLayout);
